// ---
import React from "react";
import {AbstractReactComponent, field} from "mc/lib";
import * as subjektFormatter from "mc/lib/utils/subjektFormatter";
import ParovaniPlatebApi from "../api/gen/pohledavky/ParovaniPlatebApi";

import "./FakPripadFulltextField.scss";

/**
 * Komponenta fulltextového hledání případu - našeptávač.
 */
class FakPripadFulltextField extends AbstractReactComponent {
    constructor(props) {
        super(props);
    }

    static PropTypes = {
        placeholder: React.PropTypes.string,
        onFilterSuggestions: React.PropTypes.func,
    };

    // TODO [R: dokumentace]
    static defaultProps = {
        apiRequestDelay: 250,
        placeholder: "Vyhledat případ...",
        onFilterSuggestions: (value) => {
            return ParovaniPlatebApi.findPripadFulltext(value);
        }
    };

    renderSuggestion = (i, active, getItemValue) => {
        return <div className={active ? "active row-wrapper" : "row-wrapper"}>
            <div className="head-title">
                <div className="nazev text-truncate">{
                    i.subjekt
                        ? subjektFormatter.getUplnaIdentifikace(i.subjekt)
                        : `Případ č. ${i.id} (bez subjektu)`}
                </div>
            </div>
            <div className="desc">
                <div className="nazev text-truncate">{"VS:" + (i.vs == null ? " " : i.vs)}</div>
                <div className="nazev text-truncate">{"SS: " + (i.ss == null ? " " : i.ss)}</div>
            </div>
        </div>
    };

    render() {
        const {className, onFilterSuggestions, placeholder, ...other} = this.props;

        let classNameCls = (className || "") + " pripad-fulltext-field";

        return (
            <field.ApiObjectSuggest
                minCharsForFilter={3}
                placeholder={placeholder}
                className={classNameCls}
                filterSuggestions={onFilterSuggestions}
                getItemValue={(item) => ""}
                renderSuggestion={this.renderSuggestion}
                value={null}
                {...other}
            />
        )
    }
}
export default FakPripadFulltextField;
